import styled from 'styled-components/macro';
import { ReactComponent as QuestionIcon } from '../../../assets/svg/question-icon.svg';

const QuestionMark = styled(QuestionIcon)``;

export default QuestionMark;
